import { render, staticRenderFns } from "./UserProfileLogs.vue?vue&type=template&id=2a38c0e4&scoped=true&"
import script from "./UserProfileLogs.vue?vue&type=script&lang=js&"
export * from "./UserProfileLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileLogs.vue?vue&type=style&index=0&id=2a38c0e4&prod&lang=scss&scoped=true&"
import style1 from "./UserProfileLogs.vue?vue&type=style&index=1&id=2a38c0e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38c0e4",
  null
  
)

export default component.exports